export default __webpack_public_path__ + "static/media/wave-desktop.d044eb47.svg";